<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label style="margin-left:0.625rem ;">房号</label>
			<a-input v-model="customerNum"  ref="customerNumInPut" placeholder="查询房号(回车键结束)"
					allowClear @pressEnter="showOneData" style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;"/>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="400"   ref="mTable"
						  resizable highlight-hover-row :loading="loading"   size="mini" >
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum" width="85"></vxe-table-column>
				<vxe-table-column title="立户" field="Lihu" width="85" :formatter="getLiHuStatus"></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
				<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
				<vxe-table-column title="表状态" field="MeterState" :formatter="getMeterState"></vxe-table-column>
				<vxe-table-column title="上次抄表读数" field="ActionResult" ></vxe-table-column>
				<vxe-table-column title="本次抄表读数" field="readdata"></vxe-table-column>
				<vxe-table-column title="最新用水量" field="PID" :formatter="getUseCount"></vxe-table-column>
				<vxe-table-column title="操作" field="PID">
					<template #default="{ row }">
						<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史用水量</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<div id="myCharts"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data(){
			return {
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				list:[],
				loading:false,
				myChart:null,
				theMonth:6,
				customerNum:null,
			}
		},
		methods:{
			showOneData(){
				if(this.customerNum  ==null || this.customerNum.length == 0 || this.customerNum == undefined){
					this.list = this.dataList;
					return;
				}
				this.$refs.customerNumInPut.blur();
				let temp = null;
				for(var i = 0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.customerNum == this.customerNum){
						temp = item;
						break;
					}
				}
				if(temp!=null){
					this.list = [];
					this.list.push(temp);
				}else{
					this.$message.error('用户号不存在');
					this.list = this.dataList;
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getUseCount({cellValue}){
				 const item = this.list.find(item => item.PID === cellValue);
				 return item.readdata - item.ActionResult;
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryData:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getLiHuStatus({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getLiHUList());
			},
			showHistoryData(row){
				console.log(row);
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.GET_METER_USE_COUNT_URL);
				let param = {meterId:row.PID,theMonth:this.theMonth};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.drawEcharts(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			drawEcharts(result){
				var xData = [];
				var valueData = [];
				for(var i =0 ;i<result.length;i++){
					var item = result[i];
					xData.push(item.readTime);
					valueData.push(item.useCount);
				}
				var x = "最近"+this.theMonth+"个月的用水量";
				var option = {
					title:{
						text:x
					},
					xAxis:{
						data:xData,
						type:'category'
					},
					yAxis: {
					    type: 'value'
					},
					series: [
					    {
							data: valueData,
							type: 'bar'
					    }
					]
				};
				this.myChart.setOption(option);
			},
		},
		created() {
			this.queryNeighbors();
			
		},
		mounted(){
			var chartDom = document.getElementById('myCharts');
			this.myChart = echarts.init(chartDom);
		}
	}
</script>

<style>
	#myCharts{
		width: 100%;
		height: 18.75rem;
	}
</style>
